import DiscordIcon from "@/components/logos/DiscordIcon";
import XIcon from "@/components/logos/XIcon";
import { Link } from "@tanstack/react-router";

const LoginLinks = () => {
  return (
    <div className="flex flex-row items-center gap-4">
      <Link
        to="https://reactor.trade/privacy-policy"
        className="font-inter text-xs font-medium leading-[1.21] text-[#686F83] transition-colors hover:text-[#686F83]/80"
      >
        Privacy Policy
      </Link>
      <Link
        to="https://reactor.trade/terms-of-use"
        className="font-inter text-xs font-medium leading-[1.21] text-[#686F83] transition-colors hover:text-[#686F83]/80"
      >
        Terms & Condition
      </Link>
      <a
        href="https://x.com/ReactorTrade"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-colors hover:opacity-80"
      >
        <XIcon className="size-4 text-[#686F83]" />
      </a>
      <a
        href="https://discord.com/invite/hc29r9UjCF"
        target="_blank"
        rel="noopener noreferrer"
        className="transition-colors hover:opacity-80"
      >
        <DiscordIcon className="size-4 text-[#686F83]" />
      </a>
    </div>
  );
};

export default LoginLinks;
